import axios, { AxiosResponse } from 'axios'
import { ArquivoDto, AtendimentosQueryResponse } from '../../../atendimento/core/_models'
import { ID } from '../../../../../../_metronic/helpers'

const API_URL = process.env.REACT_APP_API_URL
const ATENDIMENTO_URL = `${API_URL}/atendimentos`

/**
 * Busca os atendimentos ASO não gerados pelo profissional auntenticado
 * @param query string
 * @returns AtendimentosQueryResponse - AtendimentoList[]
 */
export const getAtendimentosAsoNotGenerated = (
  query: string
): Promise<AtendimentosQueryResponse> => {
  return axios
    .get(`${ATENDIMENTO_URL}/aso/responsavel/gerar?${query}`)
    .then((d: AxiosResponse<AtendimentosQueryResponse>) => d.data)
}

/**
 * Gera um ASO
 * @param atendimentoId Identificador do atendimento
 * @returns ArquivoDto
 */
export const generateAso = (atendimentoId: ID): Promise<ArquivoDto> => {
  return axios
    .put(`${ATENDIMENTO_URL}/aso/generate/${atendimentoId}`)
    .then((resp: AxiosResponse<ArquivoDto>) => resp.data)
}

export type GeracaoLoteResultado = {
  gerados: number
  erros: number
  /** Primeiro erro, para exibir quando o lote inteiro falhar. */
  primeiroErro?: unknown
}

/**
 * Gera um lote de ASOs. O backend não tem geração em lote: dispara uma requisição por
 * atendimento, em paralelo, e devolve quantos foram gerados e quantos falharam (um erro não
 * cancela os demais).
 * @param atendimentosIds Identificadores dos atendimentos
 * @returns GeracaoLoteResultado
 */
export const generateAsoLote = async (atendimentosIds: ID[]): Promise<GeracaoLoteResultado> => {
  const resultados = await Promise.allSettled(atendimentosIds.map((id) => generateAso(id)))
  const falhas = resultados.filter((r): r is PromiseRejectedResult => r.status === 'rejected')
  return {
    gerados: resultados.length - falhas.length,
    erros: falhas.length,
    primeiroErro: falhas[0]?.reason,
  }
}
